import { fExecuteAPI } from "../../Server/Apis";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";

import { vRdxUserInfo, PutAwayRo, KernCAConfig } from "../../Redux/roStore";
import moment from "moment";
import {
  Set_SlicePutAway_HeadObject_A_DocStat,
  Set_SlicePutAway_HeadObj,
} from "./SlicePutAway";
// item
export const GCToggleSearch_ItemName_Columns = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "ItmCd", headerName: "ItmCd", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "NameFL", headerName: "NameFL", width: 90 },
  { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
  { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
  { field: "Model", headerName: "Model", width: 90 },
  { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
  { field: "BarCode", headerName: "BarCode", width: 90 },
];
export const GCToggleSearch_ItemName_Select_Arr = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];

//customer
export const xGC_Toggle_Head_BinName_GridColumns = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "UId", headerName: "Code", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "BinAttr1", headerName: "BinAttr1", width: 450 },
  // { field: "Name1", headerName: "Name1", width: 220 },
];
export const xGC_Toggle_Head_BinName_DropDown_Arr = ["Any", "Code", "Name"];

export const Summary_Grid_Columns = [
  {
    field: "A_VocTyp",
    headerName: "VocTyp",
    width: 150,
    hide: true,
  },
  {
    field: "A_VocNo",
    headerName: "VocNo",
    width: 150,
  },
  {
    field: "VocName",
    headerName: "VocName",
    width: 150,
  },
  {
    field: "A_PostDt",
    headerName: "Date",
    width: 150,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  {
    field: "A_Party",
    headerName: "Party",
    width: 150,
  },
  {
    field: "PartyName",
    headerName: "Party Name",
    width: 150,
  },
  {
    field: "BinCd",
    headerName: "BinCd",
    width: 150,
  },
  {
    field: "BinName",
    headerName: "BinName",
    width: 150,
  },

  {
    field: "A_Loc",
    headerName: "Location",
    width: 200,
    hide: true,
  },
  {
    field: "LocName",
    headerName: "Location Name",
    width: 200,
  },
  {
    field: "PA_Typ",
    headerName: "Auto",
    width: 200,
  },

  {
    field: "PA_DocStat",
    headerName: "Status",
    width: 200,
  },
];
export const statusData = [
  {
    id: "All",
    statusName: "All",
  },
  {
    id: "ENTER",
    statusName: "ENTER",
  },
  {
    id: "POST",
    statusName: "POST",
  },
];
export const Detail_Grid_columns = [
  {
    field: "P_SrNo",
    headerName: "Sr No",
    width: 50,
  },
  {
    field: "P_CardID",
    headerName: "CardID",
    width: 150,
  },
  {
    field: "P_ItmCd",
    headerName: "Item Code",
    width: 90,
    hide: true,
  },
  {
    field: "ItmName",
    headerName: "Item Name",
    width: 320,
  },
  {
    field: "P_BinCd",
    headerName: "BinCd",
    width: 50,
    hide: true,
  },
  {
    field: "BinName",
    headerName: "BinName",
    width: 300,
  },

  {
    field: "P_Qty",
    headerName: "Qty",
    width: 50,
  },
  {
    field: "P_Unit",
    headerName: "Unit",
    width: 100,
  },
  {
    field: "P_BaseQty",
    headerName: "Base Qty",
    width: 100,
  },
];
export const ErrorMsgDetail = {
  B_Srno: "", // int
  B_CardId: "",
  B_Itmcd: "",
  B_Itmcd2: "",
  B_Barcode: "",
  B_ItmName: "",
  B_BinCode: "",
  B_BinName: "",
  B_Qty: "", //Decimal
  B_Unit: "",
  B_UnitName: "",
  B_PackQty: "", //Decimal
  B_Packing: "", //Decimal
  B_BaseQty: "", //Decimal
  B_BatchNo: "",
  B_GrnQty: "",
  B_PutAwayQty: "",
  B_BalanceQty: "",
  v_P_ExpDt: "",
};

export const sTrnTyp = "WMINV03BIN";

const GetItemFullSearchArr = async (xItemName, xLoc) => {
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI("SEARCHEXACTITEM_GETROW", FinalObj);
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull?.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull?.Type?.response?.data?.message
        ? vItemSearchFull?.Type?.response?.data?.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    itemCd: xItemCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(itemUnitobj);

  const UnitInfo = await fExecuteAPI("GETITEMUNITS_GETROW", FinalObj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.Type.response.data.message
        ? UnitInfo.Type.response.data.message
        : "Error in UnitArr"
    );
    return [];
  }
};

const fItemCodeDependency = async (
  vItemSearchFull,
  setBufferObj,
  setUnit,
  defUnitValue = ""
) => {
  if (vItemSearchFull.length > 0) {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: vItemSearchFull[0].ItmCd,
      B_ItmName: vItemSearchFull[0].Name2,
      // B_Barcode: vItemSearchFull[0].BarCode,
    }));
    let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);

    if (currentUnitArr.length > 0) {
      let vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === defUnitValue;
      });
      if (!!vItemUnitSet) {
        setBufferObj((obj) => ({
          ...obj,
          B_Unit: vItemUnitSet.Unit,
          B_UnitName: vItemUnitSet.Name1,
          B_PackQty: vItemUnitSet.PackQty,
          B_Packing: vItemUnitSet.PackDesc,
        }));
      } else {
        setBufferObj((obj) => ({
          ...obj,
          B_Unit: currentUnitArr[0].Unit,
          B_UnitName: currentUnitArr[0].Name1,
          B_PackQty: currentUnitArr[0].PackQty,
          B_Packing: currentUnitArr[0].PackDesc,
        }));
      }
      // let vItemUnitSet = currentUnitArr.find((obj) => {
      //   return obj.Unit === vItemSearchFull[0].DefUnit;
      // });
      // if (!!vItemUnitSet) {
      //   setBufferObj((obj) => ({
      //     ...obj,
      //     B_Unit: vItemUnitSet.Unit,
      //     B_UnitName: vItemUnitSet.Name1,
      //     B_PackQty: vItemUnitSet.PackQty,
      //   }));
      // } else {
      //   let vItemUnitSet = currentUnitArr.find((obj) => {
      //     return obj.Unit === vItemSearchFull[0].PurUOM;
      //   });
      //   if (!!vItemUnitSet) {
      //     setBufferObj((obj) => ({
      //       ...obj,
      //       B_Unit: vItemUnitSet.Unit,
      //       B_UnitName: vItemUnitSet.Name1,
      //       B_PackQty: vItemUnitSet.PackQty,
      //     }));
      //   } else {
      //     setBufferObj((obj) => ({
      //       ...obj,
      //       B_Unit: currentUnitArr[0].Unit,
      //       B_UnitName: currentUnitArr[0].Name1,
      //       B_PackQty: currentUnitArr[0].PackQty,
      //     }));
      //   }
      // }
    }
    setTimeout(() => {
      const element = document.querySelector('[tabindex="103"]');
      element?.focus();
    }, 500);
    // document.getElementsByName("GC_Toggle_Head_BinName_Name")[0]?.focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};

const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", FinalObj);
  if (vItemSearch?.Type?.toUpperCase() === "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};
const fValidationHead_Client = (
  vRdxHead,
  setErrorMsg,
  vMediaQuery,
  fSummary
) => {
  let iRes = true;
  // let xObjHasNullOrUndefinevale =
  //   fCheck_Value_Null_Or_Undefined_ShowAlert(vRdxHead);
  // fAlertToast("WARNING", xObjHasNullOrUndefinevale);

  if (
    vRdxHead.DocType === "" ||
    vRdxHead.DocType === null ||
    vRdxHead.DocType === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      DocType: "Document Name should not be empty",
    }));
    iRes = false;
  }
  if (
    vRdxHead.DocNo === "" ||
    vRdxHead.DocNo === null ||
    vRdxHead.DocNo === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      DocNo: "Document No should not be empty",
    }));
    iRes = false;
  }
  if (
    vRdxHead.Loc === "" ||
    vRdxHead.Loc === null ||
    vRdxHead.Loc === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, Loc: "Location should not be empty" }));
    iRes = false;
  }

  // default format so no need to check format
  if (
    vRdxHead.Date === "" ||
    vRdxHead.Date === null ||
    vRdxHead.Date === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      Date: "Date should not be empty",
    }));
    iRes = false;
  }

  if (
    vRdxHead.UnloadingBin === "" ||
    vRdxHead.UnloadingBin === null ||
    vRdxHead.UnloadingBin === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      UnloadingBin: "UnloadingBin should not be empty",
    }));
    iRes = false;
  }

  if (vRdxHead.A_DocStat !== "ENTER") {
    fAlertToast("FAILED", "Document status should be  Enter");
    iRes = false;
  }

  if (!iRes && vMediaQuery) {
    fSummary();
  }
  return iRes;
};

const fValidationDetail_Client = (sBufferObj, setErrorMsgDetail) => {
  let iRes = true;
  if (
    sBufferObj.B_Srno === "" ||
    sBufferObj.B_Srno === null ||
    sBufferObj.B_Srno === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Srno: "Serial number should not be empty",
    }));
    iRes = false;
  }
  if (
    BarcodeFlag() &&
    (sBufferObj.B_Barcode == "" ||
      sBufferObj.B_Barcode === null ||
      sBufferObj.B_Barcode === undefined)
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Barcode: "Barcode should not be empty",
    }));
    iRes = false;
    return;
  }
  if (
    sBufferObj.B_CardId === "" ||
    sBufferObj.B_CardId === null ||
    sBufferObj.B_CardId === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_CardId: "CardId should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_BinCode === "" ||
    sBufferObj.B_BinCode === null ||
    sBufferObj.B_BinCode === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_BinCode: "BinCode should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_BinName === "" ||
    sBufferObj.B_BinName === null ||
    sBufferObj.B_BinName === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_BinName: "BinName should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_Itmcd === "" ||
    sBufferObj.B_Itmcd === null ||
    sBufferObj.B_Itmcd === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Itmcd: "Item code should not be empty",
    }));
    iRes = false;
  }
  if (
    sBufferObj.v_P_ExpDt === "" ||
    sBufferObj.v_P_ExpDt === null ||
    sBufferObj.v_P_ExpDt === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      v_P_ExpDt: "Exp date should not be empty",
    }));
    iRes = false;
  }

  if (sBufferObj.B_ItmName === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_ItmName: "Item name should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_Qty === "" ||
    Number(sBufferObj.B_Qty) <= 0 ||
    (sBufferObj.B_Qty === null) | (sBufferObj.B_Qty === undefined)
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Qty: "Qty should not be zero",
    }));
    iRes = false;
  }

  if (sBufferObj.B_Unit === "") {
    setErrorMsgDetail((obj) => ({ ...obj, B_Unit: "Select unit" }));
    iRes = false;
  } else if (sBufferObj.B_PackQty === "" || Number(sBufferObj.B_PackQty) <= 0) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Unit: "Pack quantity should not be zero",
    }));
    iRes = false;
  }

  return iRes;
};
//API SaveSIHead
const fSaveHead = async (fNewDetail, sBufferObj, dispatch, navigate) => {
  const vRdxUserInfoObj = vRdxUserInfo();

  const { HeadObj } = PutAwayRo();
  // const iStatus = xSave ? HeadObj.A_DocStat : "POST"; //xSave False means Post
  let vSaveSIHeadObj = {
    vocTyp: HeadObj.DocType,
    vocNo: HeadObj.DocNo,
    vocDt: HeadObj.Date,
    srNo: sBufferObj.B_Srno,
    binCd: sBufferObj.B_BinCode,
    itmCd: sBufferObj.B_Itmcd,
    cardId: sBufferObj.B_CardId,
    qty: sBufferObj.B_Qty,
    unit: sBufferObj.B_Unit,
    baseQty: sBufferObj.B_BaseQty,
    barcode: sBufferObj.B_Barcode,
    userCd: vRdxUserInfoObj.UserID,
    v_P_ExpDt: moment(sBufferObj.v_P_ExpDt).format("MM/DD/YYYY"),
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);
  const vSaveSIHead = await fExecuteAPI("PUTAWAY_savePutAway_GETROW", FinalObj);
  if (
    vSaveSIHead?.Type?.toUpperCase() === "SUCCESS" &&
    vSaveSIHead?.ResultSet.length > 0 &&
    vSaveSIHead?.ResultSet[0]?.isVariComp == "Y"
  ) {
    dispatch(
      Set_SlicePutAway_HeadObject_A_DocStat({
        A_DocStat: "POST",
      })
    );
    fNewDetail();
    fAlertToast("SUCCESS", "Successfully Approved");
    navigate("/PutAway");
  } else if (vSaveSIHead?.Type?.toUpperCase() === "SUCCESS") {
    dispatch(
      Set_SlicePutAway_HeadObject_A_DocStat({
        A_DocStat: "ENTER",
      })
    );
    fNewDetail();
    fAlertToast("SUCCESS", "Successfully Saved");
  } else {
    fAlertToast(
      "FAILED",
      vSaveSIHead?.Status ||
        vSaveSIHead?.response?.data?.message ||
        "Fail to Save Head"
    );
  }
};

const fApproveHead = async (fNewDetail, dispatch) => {
  const { HeadObj } = PutAwayRo();

  let vApproveObj = {
    vocTyp: HeadObj.DocType,
    vocNo: HeadObj.DocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vApproveObj);
  const vApprove = await fExecuteAPI("PUTAWAY_approvePutAway_GETROW", FinalObj);
  if (vApprove?.Type?.toUpperCase() === "SUCCESS") {
    dispatch(
      Set_SlicePutAway_HeadObject_A_DocStat({
        A_DocStat: "POST",
      })
    );
    fAlertToast("SUCCESS", "Successfully Approved");
  } else if (vApprove?.Type?.toUpperCase() === "FAILED") {
    fAlertToast("FAILED", vApprove?.Status);
  } else {
    fAlertToast("FAILED", vApprove?.response?.data?.message);
  }
};

const GetSIDetail = async () => {
  const { HeadObj } = PutAwayRo();
  let iSIDetailObj = {
    vocTyp: HeadObj.DocType,
    vocNo: HeadObj.DocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const iSIDetailResult = await fExecuteAPI(
    "PUTAWAY_loadDetail_GETROW",
    FinalObj
  );
  if (iSIDetailResult?.Type?.toUpperCase() === "SUCCESS") {
    if (iSIDetailResult?.ResultSet?.length > 0) {
      return iSIDetailResult.ResultSet;
    } else {
      return [];
    }
  } else if (iSIDetailResult?.Type?.toUpperCase() === "FAILED") {
    fAlertToast("FAILED", iSIDetailResult?.Status);
  } else {
    fAlertToast("FAILED", iSIDetailResult?.response?.data?.Status);
  }
};
const fLoad_Grid = async (setDetailGridData) => {
  const iSIDetail = await GetSIDetail();
  if (iSIDetail?.length > 0) {
    let GridID = iSIDetail?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setDetailGridData(GridID);
  } else {
    setDetailGridData([]);
  }
};

const GetValidateHead_Server = async () => {
  const { HeadObj } = PutAwayRo();
  let vValidateHeadObj = {
    vocTyp: HeadObj.DocType,
    vocNo: HeadObj.DocNo,
  };
  const vValidateHead = await fExecuteAPI(
    "PUTAWAY_checkPutawayCompleted_GETROW",
    vValidateHeadObj
  );
  if (vValidateHead.Type?.toUpperCase() === "SUCCESS") {
    return vValidateHead.ResultSet ? vValidateHead.ResultSet : [];
  } else {
    fAlertToast("FAILED", vValidateHead?.response?.data?.Status);
    return [];
  }
};
//API VALIDATE_HEAD_WMINV03_APPROVE_GETROW
const GetValidateDetail_Server = async (dispatch, sBufferObj) => {
  const { HeadObj } = PutAwayRo();

  let vValidateHeadApproveObj = {
    vocTyp: HeadObj.DocType,
    vocNo: HeadObj.DocNo,
    srNo: sBufferObj.B_Srno,
    cardId: sBufferObj.B_CardId,
    itmCd: sBufferObj.B_Itmcd.trim(),
    binCd: sBufferObj.B_BinCode,
    autoChecked: HeadObj.Auto === "A",
    baseQty: sBufferObj.B_BaseQty,
    binName: sBufferObj.B_BinName,
    locCd: HeadObj.Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vValidateHeadApproveObj);
  const vValidateHeadApprove = await fExecuteAPI(
    "PUTAWAY_validateDetails_GETROW",
    FinalObj
  );
  if (vValidateHeadApprove?.Type?.toUpperCase() === "SUCCESS") {
    return true;
  } else {
    fAlertToast("FAILED", vValidateHeadApprove?.response?.data?.message);
    return false;
  }
};

//API GETSIHEAD_GETROW to gethead
const fDisplay = async (xA_VocTyp, xVocNo, dispatch, fNewDetail) => {
  const { HeadObj } = PutAwayRo();
  let vSIHeadObj = {
    vocTyp: xA_VocTyp,
    vocNo: xVocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSIHeadObj);
  const vSIHead = await fExecuteAPI("PUTAWAY_getPutAwayHead_GETROW", FinalObj);
  if (vSIHead?.Type?.toUpperCase() === "SUCCESS") {
    dispatch(
      Set_SlicePutAway_HeadObj({
        ...HeadObj,
        DocType: vSIHead.ResultSet[0].A_VocTyp,
        DocName: vSIHead.ResultSet[0].VocName,
        DocNo: vSIHead.ResultSet[0].A_VocNo,
        Date: vSIHead.ResultSet[0].PA_DocDt,
        Loc: vSIHead.ResultSet[0].A_Loc,
        LocName: vSIHead.ResultSet[0].LocName,
        Auto: vSIHead.ResultSet[0].PA_Typ,
        UnloadingBin: vSIHead.ResultSet[0].BinCd,
        UnloadingBinName: vSIHead.ResultSet[0].BinName,
        A_DocStat: vSIHead.ResultSet[0].PA_DocStat,
      })
    );

    fNewDetail();
  }
};
export const BarcodeFlag = () => {
  const { DBKernObj } = KernCAConfig();
  if (DBKernObj?.PUT_AWAY_DBL_CHECK?.Val === "Y") return true;
  else return false;
};

export {
  GetItemFullSearchArr,
  GetUnitArr,
  fItemCodeDependency,
  GetSearchItem,
  fValidationDetail_Client,
  fValidationHead_Client,
  fLoad_Grid,
  fSaveHead,
  fApproveHead,
  GetValidateHead_Server,
  GetValidateDetail_Server,
  fDisplay,
};
